'use client'

import { cn } from '@algoacademy/design-system/shared/cn'
import { motion } from 'framer-motion'
import Link from 'next/link'

type FeatureCardProps = {
  title: string
  description: string
  href: string
  delay?: number
}

export function FeatureCard({ title, description, href, delay = 0 }: FeatureCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.6, delay, ease: 'easeOut' }}
    >
      <Link
        href={href}
        className={cn(
          'group flex h-full flex-col gap-4 rounded-2xl border border-borderPrimary bg-backgroundPrimary p-8 transition-all',
          'hover:border-algoprimary hover:bg-backgroundHoverOverlay'
        )}
      >
        <h3 className='font-semibold text-3xl text-contentPrimary tracking-tight'>{title}</h3>
        <p className='text-base text-contentSecondary leading-relaxed'>{description}</p>
        <span className='mt-auto pt-4 font-medium text-algoprimary text-sm transition-transform group-hover:translate-x-1'>
          Dowiedz sie wiecej →
        </span>
      </Link>
    </motion.div>
  )
}
